"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.network = void 0;
exports.network = {
    "mainnet": {
        bridgeAddress: "https://bridge.walletconnect.org",
        walletAddress: "https://wallet.multiversx.com/dapp/init",
        chainId: "1",
        relayAddress: "wss://relay.walletconnect.com"
    },
    "devnet": {
        bridgeAddress: "https://bridge.walletconnect.org",
        walletAddress: "https://devnet-wallet.multiversx.com/dapp/init",
        chainId: "D",
        relayAddress: "wss://relay.walletconnect.com"
    },
    "testnet": {
        bridgeAddress: "https://bridge.walletconnect.org",
        walletAddress: "https://testnet-wallet.multiversx.com/dapp/init",
        chainId: "T",
        relayAddress: "wss://relay.walletconnect.com"
    }
};
